import { useMutation } from '@tanstack/react-query';
import apiService from '../services/apiService';

export const useUpdateProperty = () => {
  return useMutation({
    mutationFn: async ({ id, formData, originalData }) => {
      const data = new FormData();
      
      if (formData.title !== originalData?.title) {
        data.append('title', formData.title);
      }
      if (formData.description !== originalData?.description) {
        data.append('description', formData.description);
      }
      if (formData.address !== originalData?.address) {
        data.append('address', formData.address);
      }
      if (formData.type !== originalData?.type) {
        data.append('type', formData.type);
      }
      if (String(formData.pricePerNight) !== String(originalData?.price)) {
        data.append('price', String(formData.pricePerNight));
      }
      if (String(formData.size) !== String(originalData?.size)) {
        data.append('size', String(formData.size));
      }
      if (String(formData.bedrooms) !== String(originalData?.bedrooms)) {
        data.append('bedrooms', String(formData.bedrooms));
      }
      if (String(formData.bathrooms) !== String(originalData?.bathrooms)) {
        data.append('bathrooms', String(formData.bathrooms));
      }
      if (formData.status !== originalData?.status) {
        data.append('status', formData.status);
      }

      formData.newImages
        .filter(img => img instanceof File)
        .forEach((image) => {
          data.append('images[]', image);
        });

      formData.features
        .filter((f) => !f.id)
        .forEach((f) => {
          data.append('features[]', f.name);
        });

      const response = await apiService.put(`/api/properties/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000,
      });
      
      return response.data;
    },
  });
};
